import {
  CmpSelectBox,
  CmpTextField,
  CmpDatePicker,
  CmpButton,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
// import { Box, Grid } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { fAlertToast } from "../../Utility/Utilitys";
import Notification_Breadcrumbs from "./Notification_BreadCrumbs";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import "./Notification.css";
import {
  NotificationPickingPending_Set,
  NotificationPickingPending_Status_Set,
} from "./SliceNotification";
export default function PickingHead() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const PKLSTypeFocusOnLoad = useRef(null);
  // const vRdxDetail = useSelector(
  //   (state) => state.SliceNotification.value.NotificationHead
  // );
  const location = useLocation();
  const vRdxuserInfo = useSelector((state) => state.login.value);

  // Navigate from DashBoard & Picking - Dec 24 2025 by Ramesh Sir
  const headObj = location.state;
  //

  let vErrorInit = {
    A_VocTyp: "",
    VocName: "",
    A_VocNo: "",
    A_VocDt: "",
    A_Loc: "",
    LocName: "",
    LoadingBayCode: "",
    LoadingBayName: "",
    A_DocStat: "",
    A_Typ: "",
    A_PKL_DocStatus: "",
    ShiftID: "",
  };
  const [sErrorMsg, setErrorMsg] = useState(vErrorInit);
  let vHeadDataInit = {
    A_VocTyp: "",
    VocName: "",
    A_VocNo: "",
    A_VocDt: "",
    A_Loc: "",
    LocName: "",
    LoadingBayCode: "",
    LoadingBayName: "",
    A_DocStat: "",
    A_Typ: "",
    A_PKL_DocStatus: "",
    ShiftID: "",
  };
  const [sHeaderData, setHeaderData] = useState({
    A_VocTyp: "",
    VocName: "",
    A_VocNo: "",
    A_VocDt: "",
    A_Loc: "",
    LocName: "",
    LoadingBayCode: "",
    LoadingBayName: "",
    A_DocStat: "",
    A_Typ: "",
    A_PKL_DocStatus: "",
    ShiftID: "",
  });

  const [sDisableSelect, SetDisableSelect] = useState(0);
  const [typeData, settypeData] = useState([
    { UId: "A", Name1: "Auto" },
    { UId: "M", Name1: "Manual" },
  ]);

  const fOnChangeInput = (e) => {
    setHeaderData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnChangeInputQty = (e) => {
    setHeaderData((obj) => ({
      ...obj,
      [e.target.name]: Number(e.target.value),
    }));
  };

  const setValidation = () => {
    setErrorMsg(vErrorInit);
    let iRes = true;
    // if (sHeaderData.SrNo === "") {
    //     setErrorMsg((obj) => ({ ...obj, SrNo: "SrNo is Empty", }));
    //     iRes = false;
    // }
    // return iRes;
  };

  const fClearErrorMsg = (e) => {
    setErrorMsg(vErrorInit);
  };

  const fNext = async (e) => {
    // NotificationPickingPending_Set
    dispatch(NotificationPickingPending_Set(sHeaderData));
    if (sHeaderData.A_Typ == "A" || sHeaderData.A_Typ == "M") {
      navigate("/PickingPendingList");
    }
    // else if (sHeaderData.A_Typ == "M") {
    //   navigate("/PickingDetail");
    // }
  };
  const fComplete = async (e) => {
    GetPost();
  };
  const fClose = async (e) => {};
  const fonLoad = (e) => {
    GetPickingHead();
  };
  //API NOTIFICATION_PICKINGHEAD_GETROW
  const GetPickingHead = async () => {
    let vPickingHeadObj = {
      VocTyp: headObj?.A_VocTyp,
      VocNo: headObj?.A_VocNo,
    };
    const vPickingHead = await fExecuteAPI(
      "NOTIFICATION_PICKINGHEAD_GETROW",
      vPickingHeadObj
    );
    if (vPickingHead.Type == "SUCCESS") {
      setHeaderData(vPickingHead.ResultSet[0]);
    } else if (vPickingHead.Type == "FAILED") {
      fAlertToast("FAILED", vPickingHead.Message);
    } else if (
      vPickingHead.response.status == 500 ||
      vPickingHead.response.status == 400
    ) {
      fAlertToast("FAILED", vPickingHead.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading PickingHead");
    }
  };

  //API NOTIFICATION_PICKINGPOSTING_GETROW
  const GetPost = async () => {
    let vPostObj = {
      G_VocTyp: headObj?.A_VocTyp,
      G_VocNo: headObj?.A_VocNo,
      UserCd: vRdxuserInfo.UserID,
    };
    const vPost = await fExecuteAPI(
      "NOTIFICATION_PICKINGPOSTING_GETROW",
      vPostObj
    );
    if (vPost.Type == "SUCCESS") {
      setHeaderData((obj) => ({ ...obj, A_PKL_DocStatus: "POST" }));
      dispatch(
        NotificationPickingPending_Status_Set({ A_PKL_DocStatus: "POST" })
      );
      fAlertToast("SUCCESS", "Successfully posted");
    } else if (vPost.Type == "FAILED") {
      fAlertToast("FAILED", vPost.Message);
    } else if (vPost.response.status == 500 || vPost.response.status == 400) {
      fAlertToast("FAILED", vPost.response.data.message);
    } else {
      fAlertToast("FAILED", "Error in Posting");
    }
  };

  useEffect(() => {
    fonLoad();
  }, []);
  useEffect(() => {
    PKLSTypeFocusOnLoad.current?.focus();
  }, []);

  return (
    <div className="container-fluid py-2 ">
      {/* <div>
        <Notification_Breadcrumbs />
      </div> */}
      <div
      // className="Instantg-picking-detail "
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={2}
            style={{
              textAlign: "center",
            }}
            columns={{ xs: 24, sm: 12, md: 12 }}
          >
            <Grid item xs={12} sm={3} md={3}>
              <CmpTextField
                xref={PKLSTypeFocusOnLoad}
                xLabelText={"PKLst.Typ"}
                xVariant={"outlined"}
                xValue={sHeaderData?.A_VocTyp}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"A_VocTyp"}
                xError={sErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocTyp}
              />
            </Grid>
            <Grid item xs={12} sm={9} md={9}>
              <CmpTextField
                xLabelText={"PKLst.Name"}
                xVariant={"outlined"}
                xValue={sHeaderData?.VocName}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"VocName"}
                xError={sErrorMsg.VocName === "" ? false : true}
                xErrorMessage={sErrorMsg.VocName}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <CmpTextField
                xLabelText={"PKLst.No"}
                xVariant={"outlined"}
                xValue={sHeaderData?.A_VocNo}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"A_VocNo"}
                xError={sErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocNo}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <CmpDatePicker
                xLabelText={"PKLst.Date"}
                xValue={sHeaderData?.A_VocDt}
                xOnChange={(newValue) =>
                  setHeaderData((obj) => ({ ...obj, A_VocDt: newValue.$d }))
                }
                xName={"A_VocDt"}
                xError={sErrorMsg.A_VocDt === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocDt}
              />
            </Grid>

            <Grid item xs={12} sm={3} md={3}>
              <CmpTextField
                xLabelText={"Virtl.Bin"}
                xVariant={"outlined"}
                xValue={sHeaderData?.LoadingBayCode}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"LoadingBayCode"}
                xError={sErrorMsg.LoadingBayCode === "" ? false : true}
                xErrorMessage={sErrorMsg.LoadingBayCode}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <CmpTextField
                xLabelText={"Virtl.Bin.Name"}
                xVariant={"outlined"}
                xValue={sHeaderData?.LoadingBayName}
                xOnChange={(event) => fOnChangeInput(event)}
                xReadOnly={true}
                xType={"text"}
                xName={"LoadingBayName"}
                xError={sErrorMsg.LoadingBayName === "" ? false : true}
                xErrorMessage={sErrorMsg.LoadingBayName}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <CmpSelectBox
                xLabelText="Type"
                xValue={sHeaderData?.A_Typ}
                xOnChange={(event) => fOnChangeInput(event)}
                xName={"A_Typ"}
                xData={typeData}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.A_Typ === "" ? false : true}
                xErrorMessage={sErrorMsg.A_Typ}
                xDisable={sDisableSelect == 0 ? true : false}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <CmpTextField
                xLabelText={"PikLstSt"}
                xVariant={"outlined"}
                xValue={sHeaderData?.A_DocStat}
                xOnChange={""}
                xReadOnly={true}
                xType={"text"}
                xName={"A_DocStat"}
                xError={sErrorMsg.A_DocStat === "" ? false : true}
                xErrorMessage={sErrorMsg.A_DocStat}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <CmpTextField
                xLabelText={"PickingSt"}
                xVariant={"outlined"}
                xValue={sHeaderData?.A_PKL_DocStatus}
                xOnChange={""}
                xReadOnly={true}
                xType={"text"}
                xName={"A_PKL_DocStatus"}
                xError={sErrorMsg.A_PKL_DocStatus === "" ? false : true}
                xErrorMessage={sErrorMsg.A_PKL_DocStatus}
              />
            </Grid>
          </Grid>
        </Box>

        {/* <Box sx={{ flexGrow: 1 }} className="btn-txt-center-mt">
          <Grid
            container
            spacing={1}
            columns={{ xs: 6, sm: 6, md: 6 }}
            className="text-center mt-1 "
          >
            <Grid item xs={3}>
              <CmpButton
                xbtnName="Next"
                xOnClick={fNext}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
            
            <Grid item xs={3}>
              <CmpButton
                xbtnName="Close"
                xOnClick={fClose}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
          </Grid>
        </Box> */}
      </div>
    </div>
  );
}
